import { Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { getAppInit } from 'src/services/init/init.service';
import { AvatarIcon } from '../../Media/Icon/Icons/Icons';

import {
  SettingsBlockUserBlock,
  SettingsAvatar,
  SettingsContact,
  AvatarText,
} from './UserIdentitify.style';
import { getMyAccountHeader } from 'src/shared/config/config';
import { useGetUserQuery } from 'src/services/account/accountServiceApi';

export const UserIdentitify = () => {
  const [userDetails, setUserDetails]: any = useState(null);
  const { data: userData } = useGetUserQuery({});

  useEffect(() => {
    getAppInit().then(async (response) => {
      const myAccount = getMyAccountHeader(response);
      setUserDetails(myAccount);
    });
  }, []);

  // @ts-ignore
  const fullName = `${userData?.first_name ?? ''} ${userData?.last_name ?? ''}`;
  // @ts-ignore
  const email = userData?.email ?? '';

  const checkFirstNameAvailableOrNot = userDetails && userDetails?.first_name;
  // @ts-ignore
  const avatarText = userData?.first_name
    ? `${userData?.first_name?.charAt(0)}${userData?.last_name?.charAt(0)}`
    : '';
  return (
    <SettingsBlockUserBlock>
      {userDetails && (
        <>
          {checkFirstNameAvailableOrNot && (
            <SettingsAvatar>
              <AvatarIcon />
              <AvatarText>
                <Typography
                  variant="h2Bold700"
                  sx={{ marginLeft: '12px', textAlign: 'center', textTransform: 'uppercase' }}
                  color="white"
                  component="span"
                >
                  {avatarText.trim()}
                </Typography>
              </AvatarText>
            </SettingsAvatar>
          )}
          <SettingsContact>
            {checkFirstNameAvailableOrNot && (
              <Typography
                variant="h3Bold"
                sx={{ marginLeft: '10px', textTransform: 'capitalize' }}
                color="gray.900"
              >
                {fullName}
              </Typography>
            )}
            <Typography
              variant="h1"
              sx={{ marginTop: '4px', marginLeft: '12px' }}
              color="darkSlateGray"
            >
              {email}
            </Typography>
          </SettingsContact>
        </>
      )}
    </SettingsBlockUserBlock>
  );
};
